import React from "react";
import Navbar from "../../components/Navbar";
import ListPJ from "../../components/ListPJ";
import PJsvg from "../../assets/navbar/Pessoa_juridica_on_light_blue.svg";
import { ImPlus } from "react-icons/im";
import * as S from "./styles";

import { useHistory, useLocation } from "react-router-dom";

export default function PJList() {
  const history = useHistory();
  const params = useQuery();

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  return (
    <>
      <Navbar />
      <S.Wrapper>
        <S.Header>
          <S.BoxUser>
            <S.Image src={PJsvg} />
            <div>
              <S.Title>Pessoa Jurídica</S.Title>
              <S.Description>Cadastro geral de pessoa jurídica</S.Description>
            </div>
          </S.BoxUser>

          <S.AddNew onClick={() => history.push("/cadastro-pessoa-juridica")}>
            <ImPlus
              style={{
                margin: "0px 0px 30px",
              }}
            />
            <S.Image src={PJsvg} />
          </S.AddNew>
        </S.Header>

        <ListPJ
          filter={params.get("filter") || ""}
          pageFilter={parseInt(params.get("page") || "0")}
          history={history}
        />
      </S.Wrapper>
    </>
  );
}
